import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_INCIDENT } from "../../../utils/constants";
import { IncidentInterface } from "../../../models/Incident";
import incidentService from "../../../services/incidentService";

const useIncident = (page: number, pageSize: number) =>
  useQuery<IncidentInterface[], Error>({
    queryKey: [
      CACHE_KEY_INCIDENT,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => incidentService.GetAll(page, pageSize),
  });

export default useIncident;
